<template>
  <div v-if="!isSymposium" class="wrap-banner">
    <Logo />
    <Carousel />
  </div>
</template>

<script>
import { mapState } from 'vuex'

const Logo = () => import('./Logo')
const Carousel = () => import('./Carousel')

export default {
  components: {
    Logo,
    Carousel
  },

  computed: {
    ...mapState({
      isSymposium: state => state.symposium.isSymposium
    }),
  },
}
</script>
